import { PostalAddress } from '../../common/model/postal-address';
import { ModelBase } from '../../core/model/model-base';
import { FaultNotification } from '../../fault-notification/model/faultNotification';
import { TenantCategory, TenantState, TenantStateToString } from './const/enums';
import { ContactBalanceTransaction } from './contact-balance-transaction';
import { ContactDocument } from './contact-document';
import { Contract } from './contract';
import { DocumentInformationNoteModel, DocumentNote } from '../../core/model/information-note';
import { RentApplication } from './rent-application';
import { SelectionItem } from '../../core/component/select/select.component';
import { ContactPaymentInformationPerCompany } from './contact-payment-information-per-company';
import { ContactB2CSubscriptionInformation } from './contact-b2cSubscription-information';

export enum ContactIdKind {
  None = 0,
  SwedishSSN = 10,
  SwedishOrganizationNumber = 11,
  SwedishCoordinationNumber = 12,
  DanishSSN = 20,
  DanishOrganizationNumber = 21,
  FinnishSSN = 30,
  FinnishOrganizationNumber = 31,
  NorwegianSSN = 40,
  NorwegianOrganizationNumber = 41,
  BirthdayIso8601 = 200,
  FreeText = 201,
  InternationalPassportNumber = 202,
}

export enum B2CContactSaveAction {
  None = 0,
  EnableAll = 1,
  DisableAll = 2,
  //AcceptSuggestion = 4,
  AcceptAndEnableAll = 5,
}

export class Contact extends ModelBase implements DocumentNote {
  constructor() {
    super();
    this.category = TenantCategory.PhysicalPerson;
    this.leaseAgreements = [];
    this.rentApplications = [];
    this.contactBalanceTransactions = [];
    this.contactPaymentInformationPerCompanies = [];
    this.b2CSubscriptionContactInformations = [];
    this.documents = [];
    this.state = TenantState.Registered;
    this.invoiceAddress = new PostalAddress();
    this.b2cSaveAction = B2CContactSaveAction.None;
  }

  webUserLastLogin: Date;
  webUserCreated: Date;
  b2cSaveAction: B2CContactSaveAction;
  bankAccount: string;
  category: TenantCategory;
  idType = ContactIdKind.None;
  contactIdentification: string;
  counterpart: string;
  useCounterpart: boolean;
  email: string;
  emailInvoicing: string;
  creditBalance: number;
  invoiceAddress: PostalAddress;
  documentInformationNotes: DocumentInformationNoteModel[];

  get hasLeaseAgreements(): boolean {
    return this.leaseAgreements?.length > 0;
  }
  get hasRentApplications(): boolean {
    return this.rentApplications?.length > 0;
  }
  get hasContactBalanceTransactions(): boolean {
    return this.contactBalanceTransactions?.length > 0;
  }

  get hasDirectDebitConsents(): boolean {
    return this.contactPaymentInformationPerCompanies?.length > 0;
  }

  get hasB2CSubscriptions(): boolean {
    return this.b2CSubscriptionContactInformations?.length > 0;
  }

  get hasDocuments(): boolean {
    return this.documents?.length > 0;
  }
  get isRegistered() {
    return this.state === TenantState.Registered;
  }
  leaseAgreements: Contract[];
  rentApplications: RentApplication[];
  contactBalanceTransactions: ContactBalanceTransaction[];
  contactPaymentInformationPerCompanies: ContactPaymentInformationPerCompany[];
  b2CSubscriptionContactInformations: ContactB2CSubscriptionInformation[];
  faultNotifications: FaultNotification[];
  documents: ContactDocument[];
  eInvoiceAddress: string;
  eInvoiceSpecified: boolean;
  name: string;
  noJointDebiting: boolean;
  number: number;
  phone: string;
  referenceName: string;
  vatNumber: string;
  registrationKey: string;
  userAccountText: string;
  invoiceAddressString: string;
  note: string;
  state: TenantState;
  webUserUserName: string;
  applyCreditOnInvoices: boolean;

  get stateCaption(): string {
    return TenantStateToString(this.state);
  }

  toString() {
    return `${this.name}`;
  }

  toSelectionItem() {
    if (this.number) {
      return new SelectionItem(`${this.number ? this.number + ', ' : ''}${this.name}`, this.id);
    }
    return super.toSelectionItem();
  }
}
